var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("symbol", {
    id: "Grid",
    viewBox: "-64.5 -64.5 129 129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_102_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_110_",
    height: 128,
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    },
    width: 128,
    x: -64,
    y: -64
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    d: "M36.95,37.82C27.32,46.32,14.2,51,0,51 c-14.27,0-27.39-4.62-36.96-13.01C-47.45,28.79-53,15.65-53,0c0-15.58,5.55-28.69,16.04-37.92C-27.36-46.35-14.24-51,0-51 c14.17,0,27.29,4.71,36.95,13.25C47.45-28.45,53-15.4,53,0C53,15.47,47.45,28.55,36.95,37.82z",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    d: "M0,55L0,55L0,55c-29.59,0-57-19.01-57-55 c0-35.8,27.41-55,57-55h0h0c29.59,0,57,19.69,57,55C57,35.51,29.59,55,0,55z",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    d: "M0-43c-12.29,0-23.54,3.94-31.68,11.09 C-40.39-24.25-45-13.21-45,0c0,29.7,22.6,43,45,43c21.67,0,45-13.46,45-43S21.67-43,0-43L0-43z",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_106_",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    },
    x1: -0.01,
    x2: -0.01,
    y1: 51,
    y2: -51
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_105_",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    },
    x1: -16,
    x2: -16,
    y1: 48.95,
    y2: -48.93
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_104_",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    },
    x1: 15.99,
    x2: 15.99,
    y1: 48.91,
    y2: -48.93
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_103_",
    style: {
      fill: "none",
      stroke: "#4285F4",
      strokeMiterlimit: 10
    },
    x1: 53,
    x2: -53,
    y1: 0.08,
    y2: 0.08
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.53,106.01c-3.46,0-6.28-2.82-6.28-6.29V61.34c0-3.46,2.82-6.28,6.28-6.28h3.55v50.96H12.53z",
    style: {
      fill: "#F15A24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.08,57.05v46.96h-1.55c-2.36,0-4.28-1.93-4.28-4.29V61.34c0-2.36,1.92-4.28,4.28-4.28H14.08 M18.08,53.05h-5.55c-4.57,0-8.28,3.72-8.28,8.28v38.38c0,4.57,3.72,8.29,8.28,8.29h5.55V53.05L18.08,53.05z",
    style: {
      fill: "#C1272D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.17,106.01V55.05h3.55c3.46,0,6.28,2.82,6.28,6.28v38.38c0,3.47-2.82,6.29-6.28,6.29H112.17z",
    style: {
      fill: "#F15A24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,57.05c2.36,0,4.28,1.92,4.28,4.28v38.38c0,2.37-1.92,4.29-4.28,4.29h-1.55V57.05H115.72 M115.72,53.05h-5.55v54.96h5.55c4.56,0,8.28-3.72,8.28-8.29V61.34C124,56.77,120.29,53.05,115.72,53.05L115.72,53.05z",
    style: {
      fill: "#C1272D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.0591,
    x2: 64.0591,
    y1: 15.2752,
    y2: 119.0153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000566911,
    style: {
      stopColor: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1775,
    style: {
      stopColor: "#B2C2CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    style: {
      stopColor: "#B4C9D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6614,
    style: {
      stopColor: "#8AA6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8649,
    style: {
      stopColor: "#7795A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.78,122c-3.21,0-5.82-2.58-5.82-5.76V44.46c0-3.17,2.61-5.75,5.82-5.75h40.16V21.8 l-1.38-0.45c-3.18-1.05-5.31-3.96-5.31-7.26c0-4.22,3.47-7.65,7.75-7.65c4.27,0,7.74,3.43,7.74,7.65c0,3.3-2.14,6.21-5.31,7.26 l-1.38,0.45v16.9l40.17-0.01c3.21,0,5.83,2.58,5.83,5.75l0.12,9.98v52.43h-0.12v9.37c0,3.18-2.61,5.76-5.83,5.76H22.78z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,8.44c3.17,0,5.74,2.54,5.74,5.65c0,2.43-1.58,4.59-3.94,5.36l-1.81,0.59l-1.81-0.59 c-2.36-0.78-3.94-2.93-3.94-5.36C58.25,10.97,60.83,8.44,64,8.44 M105.22,40.7c2.11,0,3.82,1.68,3.83,3.8l0.12,9.91v50.46h-0.12v4 v7.37c0,2.07-1.72,3.76-3.82,3.76H22.78c-2.11,0-3.82-1.69-3.82-3.76v-7.37V44.46c0-2.07,1.72-3.75,3.82-3.75h38.16h2.11v0l4,0 L105.22,40.7 M64,4.44c-5.37,0-9.75,4.33-9.75,9.65c0,4.26,2.81,7.88,6.69,9.16v13.46H22.78c-4.32,0-7.82,3.48-7.82,7.75v64.41 v7.37c0,4.28,3.51,7.76,7.82,7.76h82.45c4.32,0,7.82-3.48,7.82-7.76v-7.37h0.12V54.41l-0.12-9.96c0-4.28-3.52-7.75-7.82-7.75 l-38.17,0.01V23.25c3.88-1.28,6.69-4.9,6.69-9.16C73.74,8.77,69.36,4.44,64,4.44L64,4.44z",
    style: {
      fill: "#658CA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,78.31c6.34,0,11.5-5.16,11.5-11.5 c0-6.34-5.16-11.5-11.5-11.5s-11.5,5.16-11.5,11.5C31.14,73.15,36.3,78.31,42.64,78.31z",
    style: {
      fill: "#FFFFFF",
      stroke: "#666666",
      strokeWidth: 4,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.95,55.28c-6.34,0-11.5,5.16-11.5,11.5 c0,6.34,5.16,11.5,11.5,11.5c6.34,0,11.5-5.16,11.5-11.5C96.45,60.43,91.3,55.28,84.95,55.28z",
    style: {
      fill: "#FFFFFF",
      stroke: "#666666",
      strokeWidth: 4,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.85,107.55H44.15 c-3.46,0-6.27-2.81-6.27-6.27v-0.56c0-3.46,2.81-6.27,6.27-6.27h39.71c3.46,0,6.27,2.81,6.27,6.27v0.56 C90.12,104.75,87.32,107.55,83.85,107.55z",
    style: {
      fill: "#FFFFFF",
      stroke: "#666666",
      strokeWidth: 4,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 11.98,
    style: {
      fill: "#666666",
      stroke: "#666666",
      strokeWidth: 0.7282,
      strokeMiterlimit: 10
    },
    width: 1.36,
    x: 53.67,
    y: 95.21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.98,
    style: {
      fill: "#666666",
      stroke: "#666666",
      strokeWidth: 0.7282,
      strokeMiterlimit: 10
    },
    width: 1.36,
    x: 63.32,
    y: 95.21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.98,
    style: {
      fill: "#666666",
      stroke: "#666666",
      strokeWidth: 0.7282,
      strokeMiterlimit: 10
    },
    width: 1.36,
    x: 72.97,
    y: 95.21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.98,
    style: {
      fill: "#666666",
      stroke: "#666666",
      strokeWidth: 0.7282,
      strokeMiterlimit: 10
    },
    width: 1.36,
    x: 82.62,
    y: 95.21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.99,
    style: {
      fill: "#666666",
      stroke: "#666666",
      strokeWidth: 0.7282,
      strokeMiterlimit: 10
    },
    width: 1.36,
    x: 44.02,
    y: 95.19
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 13.97,
    r: 4.03,
    style: {
      fill: "#FF5252"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.67,86.83c-0.88,0-1.67-0.45-2.13-1.19c-0.46-0.75-0.5-1.66-0.1-2.44l2.74-5.41l2.6-4.82 c0.44-0.81,1.28-1.31,2.2-1.31c0.93,0,1.78,0.51,2.22,1.34l5.32,10.17c0.41,0.78,0.38,1.7-0.08,2.45s-1.26,1.21-2.14,1.21H58.67z",
    style: {
      fill: "#FF5252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.99,73.16c0.35,0,0.7,0.18,0.89,0.54l2.61,4.98l2.71,5.19c0.35,0.67-0.13,1.46-0.89,1.46H64 h-5.33c-0.75,0-1.23-0.79-0.89-1.45l2.74-5.41l2.59-4.79C63.3,73.34,63.64,73.16,63.99,73.16 M63.99,70.16 c-1.47,0-2.82,0.8-3.52,2.1l-2.59,4.79l-0.02,0.03l-0.02,0.03l-2.74,5.41c-0.63,1.25-0.57,2.71,0.16,3.9 c0.73,1.19,2.01,1.91,3.41,1.91H64h5.31c1.41,0,2.69-0.72,3.42-1.93c0.73-1.21,0.78-2.68,0.12-3.93l-2.71-5.19l-2.61-4.98 C66.84,70.98,65.48,70.16,63.99,70.16L63.99,70.16z",
    style: {
      fill: "#C1272D"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 28,
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2625,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 83.75,
    y2: 83.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 128,
    y1: 128,
    y2: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,4.26c32.94,0,59.74,26.8,59.74,59.74S96.94,123.74,64,123.74S4.26,96.94,4.26,64S31.06,4.26,64,4.26 M64,4 C30.86,4,4,30.86,4,64s26.86,60,60,60s60-26.86,60-60S97.14,4,64,4L64,4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.97,115.97H20.03 c-4.42,0-8.03-3.61-8.03-8.03V20.03c0-4.42,3.61-8.03,8.03-8.03h87.94c4.42,0,8.03,3.61,8.03,8.03v87.91 C116,112.36,112.39,115.97,107.97,115.97z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2578,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,124H28c-4.4,0-8-3.6-8-8 V12c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v104C108,120.4,104.4,124,100,124z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2628,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77,108H14.23 C8.6,108,4,103.4,4,97.77V30.28c0-5.63,4.6-10.23,10.23-10.23h99.54c5.63,0,10.23,4.6,10.23,10.23v67.48 C124,103.4,119.4,108,113.77,108z",
    style: {
      opacity: 0.61,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.2627,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    height: 128,
    style: {
      opacity: 0.2
    },
    width: 128,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_2_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_3_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -28,
    x2: -28,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -24,
    x2: -24,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -20,
    x2: -20,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -16,
    x2: -16,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -12,
    x2: -12,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -8,
    x2: -8,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -4,
    x2: -4,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 0,
    x2: 0,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4,
    x2: 4,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8,
    x2: 8,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 12,
    x2: 12,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 16,
    x2: 16,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 20,
    x2: 20,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 24,
    x2: 24,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 28,
    x2: 28,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 36,
    x2: 36,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 40,
    x2: 40,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 44,
    x2: 44,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 48,
    x2: 48,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 52,
    x2: 52,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 56,
    x2: 56,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 60,
    x2: 60,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 64,
    x2: 64,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 68,
    x2: 68,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 72,
    x2: 72,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 76,
    x2: 76,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 80,
    x2: 80,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 84,
    x2: 84,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 88,
    x2: 88,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 92,
    x2: 92,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 96,
    x2: 96,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 100,
    x2: 100,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 104,
    x2: 104,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 108,
    x2: 108,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 112,
    x2: 112,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 116,
    x2: 116,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 120,
    x2: 120,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 124,
    x2: 124,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 128,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 132,
    x2: 132,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 136,
    x2: 136,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 137,
    x2: 137,
    y1: 166.05,
    y2: -25.95
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 144,
    x2: 144,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 148,
    x2: 148,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 152,
    x2: 152,
    y1: 160,
    y2: -32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 156,
    x2: 156,
    y1: 160,
    y2: -32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -28,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -24,
    y2: -24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -20,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -16,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -8,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: -4,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 24,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 28,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 36,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 44,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 52,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 56,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 60,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 68,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 76,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 80,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 84,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 88,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 92,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 96,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 100,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 104,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 108,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 112,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 116,
    y2: 116
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 120,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 124,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 132,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 136,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 140,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 144,
    y2: 144
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 148,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 152,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: -32,
    x2: 160,
    y1: 156,
    y2: 156
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75-31.75v191.5h-191.5v-191.5H159.75 M160-32H-32v192h192V-32L160-32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 128,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    width: 4,
    x: 124,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 66 -62)",
    width: 4,
    x: 62,
    y: -58
  }), /*#__PURE__*/React.createElement("rect", {
    height: 120,
    style: {
      opacity: 0.3,
      fill: "#F44336"
    },
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 190 62)",
    width: 4,
    x: 62,
    y: 66
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_46_",
    height: 128,
    style: {
      display: "inline",
      fill: "none",
      stroke: "#616161",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    transform: "matrix(-1.346904e-10 -1 1 -1.346904e-10 8.631098e-09 128)",
    width: 128,
    x: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_45_",
    height: 128,
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    width: 128,
    x: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_44_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_43_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 16,
    x2: 16,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_42_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 24,
    x2: 24,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_41_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 32,
    x2: 32,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_40_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 40,
    x2: 40,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_39_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 48,
    x2: 48,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_38_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 56,
    x2: 56,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_37_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 63.99,
    x2: 63.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_36_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 71.99,
    x2: 71.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_35_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 79.99,
    x2: 79.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_34_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 87.99,
    x2: 87.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_33_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 95.99,
    x2: 95.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_32_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 103.99,
    x2: 103.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_47_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 111.99,
    x2: 111.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_48_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 119.99,
    x2: 119.99,
    y1: 0,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_49_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 120,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_50_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 112,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_51_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 104,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_52_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 96,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_53_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 88,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_54_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 80,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_55_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_56_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 64.01,
    y2: 64.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_57_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 56.01,
    y2: 56.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_58_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 48.01,
    y2: 48.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_60_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 40.01,
    y2: 40.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_61_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 32.01,
    y2: 32.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_62_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 24.01,
    y2: 24.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_63_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 16.01,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_64_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 128,
    x2: 0,
    y1: 8.01,
    y2: 8.01
  })), /*#__PURE__*/React.createElement("use", {
    id: "XMLID_31_",
    height: 129,
    style: {
      display: "inline",
      overflow: "visible"
    },
    transform: "matrix(1 0 0 -1 64 64)",
    width: 129,
    x: -64.5,
    xlinkHref: "#Grid",
    y: -64.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotFace);
export default __webpack_public_path__ + "static/media/robot-face.4da9a5d965fd51413c759b46ff262fe1.svg";
export { ForwardRef as ReactComponent };